import { parse } from 'querystring';
import { useHistory, useLocation } from 'react-router-dom';
import * as H from 'history';

interface CustomHistory extends H.History {
  push: (url: string, params?: Record<string, string | number> | null, removeParams?: string[]) => void;
  replace: (url: string, params?: Record<string, string | number> | null, removeParams?: string[]) => void;
}
// interface CustomHistory {
//   // removeSearch: (keys: string[]) => void;
// }

export default function useCustomHistory(): CustomHistory {
  const location = useLocation();
  const history = useHistory();

  return {
    ...history,
    push: (url: string, params?: Record<string, string | number> | null, removeParams?: string[]) => {
      const qs = location.search.replace(/^[?]/gi, '');
      const parseQs = parse(qs);
      if (removeParams) {
        removeParams.map((key) => {
          parseQs[key] = null as any;
        });
      }

      history.push({
        pathname: url,
        search: `?${Object.entries({
          ...(parseQs.afterLoginEndpoint && {
            afterLoginEndpoint: parseQs.afterLoginEndpoint,
          }),
          ...(parseQs.afterPaymentEndpoint && {
            afterPaymentEndpoint: parseQs.afterPaymentEndpoint,
          }),
          ...(parseQs.beforeLoginEndpoint && {
            beforeLoginEndpoint: parseQs.beforeLoginEndpoint,
          }),
          ...(params || {}),
        })
          .reduce<string[]>((acc, [key, value]) => {
            if (value) {
              acc.push(key + '=' + value);
            }
            return acc;
          }, [])
          .join('&')}`,
      });
    },
    replace: (url: string, params?: Record<string, string | number> | null, removeParams?: string[]) => {
      const qs = location.search.replace(/^[?]/gi, '');
      const parseQs = parse(qs);
      if (removeParams) {
        removeParams.map((key) => {
          parseQs[key] = null as any;
        });
      }

      history.replace({
        pathname: url,
        search: `?${Object.entries({
          ...(parseQs.afterLoginEndpoint && {
            afterLoginEndpoint: parseQs.afterLoginEndpoint,
          }),
          ...(parseQs.afterPaymentEndpoint && {
            afterPaymentEndpoint: parseQs.afterPaymentEndpoint,
          }),
          ...(parseQs.beforeLoginEndpoint && {
            beforeLoginEndpoint: parseQs.beforeLoginEndpoint,
          }),
          ...(params || {}),
        })
          .reduce<string[]>((acc, [key, value]) => {
            if (value) {
              acc.push(key + '=' + value);
            }
            return acc;
          }, [])
          .join('&')}`,
      });
    },
    // removeSearch(keys: string[]) {
    //   const qs = location.search.replace(/^[?]/gi, '');
    //   const parseQs = parse(qs);
    //   keys.map((key) => {
    //     parseQs[key] = null as any;
    //   });
    //   history.replace({
    //     search: `?${Object.entries({
    //       ...parseQs,
    //     })
    //       .reduce<string[]>((acc, [key, value]) => {
    //         if (value) {
    //           acc.push(key + '=' + value);
    //         }
    //         return acc;
    //       }, [])
    //       .join('&')}`,
    //   });
    // },
  };
}
